import { motion } from 'framer-motion';

export function TeamBanner() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    contactSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image Column */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <div className="w-full h-[600px]">
                <img
                  src="https://public.readdy.ai/ai/img_res/07c8f279b501e55ce50b1326ee9c12ea.jpg"
                  alt="Équipe professionnelle de réparation de fenêtres à Bordeaux"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Floating Badge */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="absolute -bottom-6 -right-6 bg-orange rounded-2xl shadow-2xl p-6"
            >
              <div className="text-center">
                <div className="text-4xl font-bold text-white mb-1">500+</div>
                <div className="text-sm text-white/90 font-medium">Projets Réalisés</div>
              </div>
            </motion.div>
          </motion.div>

          {/* Content Column */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-block bg-teal/10 text-teal-dark px-6 py-2 rounded-full text-sm font-semibold mb-6">
              NOTRE EXPERTISE
            </div>

            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Des Artisans Experts en Réparation
            </h2>

            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Notre équipe de professionnels qualifiés intervient rapidement pour tous vos besoins de réparation de fenêtres, baies vitrées et volets roulants à Bordeaux et ses environs.
            </p>

            {/* Key Points */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10">
              {[
                { icon: 'ri-tools-line', title: 'Artisans Certifiés', desc: 'Équipe qualifiée et expérimentée' },
                { icon: 'ri-settings-3-line', title: 'Équipement Moderne', desc: 'Outils professionnels de pointe' },
                { icon: 'ri-time-line', title: 'Intervention Rapide', desc: 'Disponibles sous 24h' },
                { icon: 'ri-customer-service-2-line', title: 'Service Client', desc: 'Accompagnement personnalisé' }
              ].map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="flex items-start gap-4"
                >
                  <div className="w-12 h-12 bg-teal/10 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-teal-dark text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">{item.title}</h3>
                    <p className="text-sm text-gray-600">{item.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>

            {/* CTA Button */}
            <motion.button
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
              onClick={scrollToContact}
              className="px-8 py-4 bg-teal hover:bg-teal-dark text-white font-bold rounded-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-xl flex items-center gap-3 whitespace-nowrap cursor-pointer"
            >
              <span>Demander un Devis</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </motion.button>
          </motion.div>
        </div>
      </div>
    </section>
  );
}